import { DeliveryOrderService } from 'src/app/features/transport-operation/services/delivery-order.service';
import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { BaseComponent } from 'src/app/shared/components/base.component';

@Component({
  selector: 'laas-shipping-notes',
  templateUrl: './shipping-notes.component.html',
  styleUrls: ['./shipping-notes.component.scss']
})
export class ShippingNotesComponent extends BaseComponent
implements OnInit  {
  @Input() doNo: string = '';
  @Input() browserLanguage: string = '';
  @Output() closeDialog = new EventEmitter<boolean>();
  shippingNotesList: string[] | null;

  showShipNotes: boolean = true;

  constructor(injector: Injector, private deliveryOrderService: DeliveryOrderService) {
    super(injector);
    this.shippingNotesList = [];
  }

  ngOnInit(): void {
    this.deliveryOrderService.getDoShippingNotes(this.doNo, this.laasSetting.language).subscribe({
      next: result => {
        console.log(result);
        this.shippingNotesList = result.shippingNotesList;
      }
    });;
  }

  hideDialog(event:any): void{
    this.closeDialog.emit(this.showShipNotes);
  }
}
